import React from "react";

import { defaultSettings } from "./defaults/settings";
import Component from "./Component";
import Form from "./Form";

const createPlugin = (settings) => {
    const mergedSettings = { ...defaultSettings, ...settings };

    return {
        Component: (props) => <Component {...props} {...mergedSettings} />,
        FormComponent: (props) => <Form {...props} />,

        name: "indespension/content/menuItemsCarousel",
        version: "1.0.0",
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,

        createInitialState: () => ({
            menu: {},
            menuItem: {},
            menuItemPath: null,
            categoryPath: null,
            cardStyle: "square",
            progressIndicatorStyle: "dots",
            imageFit: "cover",
            font: "",
            fontWeight: "normal",
            fontColour: "#000",
            accentColour: "#000",
            arrowColour: "#FFFFFF",
            fallbackImage: "",
        }),
    };
};

export default createPlugin;
